import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/common.json';
import pt from './locales/pt/common.json';
import es from './locales/es/common.json';
import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, resolveLocale } from '../utility/locale';

const storedLocale = typeof localStorage !== 'undefined'
  ? localStorage.getItem(LOCALE_STORAGE_KEY)
  : null;

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      pt: { common: pt },
      es: { common: es },
    },
    lng: resolveLocale(storedLocale),
    fallbackLng: DEFAULT_LOCALE,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
